import {ILabelValue} from '../../../interfaces/utils';

export const NUTRITIONAL_REGIMENT: ILabelValue[]  = [
  {
    label: 'Vegetariano',
    value: 'vegetariano'
  },
  {
    label: 'Vegano',
    value: 'vegano'
  },
  {
    label: 'Frugivorista',
    value: 'frugivorista'
  },
  {
    label: 'Crudivegana',
    value: 'crudivegana'
  },
  {
    label: 'Ovivegetariana',
    value: 'ovivegetariana'
  },
  {
    label: 'Basada en plantas',
    value: 'basada en plantas'
  }
];
